/* 🤖 this file was generated by svg-to-ts */
export const mgcIconPentagonFilled: {
  name: 'pentagon-filled';
  data: string;
} = {
  name: 'pentagon-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.576 1.899c-.134.03-.337.101-.452.159-.237.12-8.342 5.993-8.579 6.216-.455.429-.698 1.151-.589 1.745.068.367 3.158 9.85 3.298 10.121.249.482.801.901 1.338 1.015.151.032 1.711.045 5.408.045s5.257-.013 5.408-.045c.538-.114 1.089-.533 1.338-1.015.141-.272 3.229-9.751 3.297-10.119.11-.596-.133-1.318-.588-1.747-.237-.223-8.341-6.096-8.577-6.215a2.367 2.367 0 0 0-.898-.215c-.088.001-.27.026-.404.055"/></svg>`
};
